window.TooltipEventScore = (function () {
    const SCOREMAP = {
        general: 'g',
        detailed: 't',
        points: 'p',
        innings: 'i',
        advant: 'a',
        team1: 'f',
        team2: 's',
    };
    const ATTR = 'tooltip-event-score';
    const ATTR_CLASSNAME = 'tooltip-event-score-classname';

    var container, innerContainer;

    const isMobileDevice = window.globalAppSettings.isMobileDevice

    var TooltipEventScore = function () {
        container = $('<div/>', {
            class: 'tooltip--event-score tooltip event-tooltip',
        });

        innerContainer = $('<div/>', {
            class: 'tooltip__inner event-tooltip-score__inner',
        }).appendTo(container);

        container.appendTo('body');

        !isMobileDevice && bindDesktopUI();
        isMobileDevice && bindMobileUI();
    };

    var bindDesktopUI = function () {
        $(document).on('mouseenter', '[' + ATTR + ']', function () {
            tooltipTriggerHandler($(this));
        });

        $(document).on('mouseleave', '[' + ATTR + ']', function () {
            hide($(this));
        });
    };

    var bindMobileUI = function () {
        const eventType = 'touchstart';
        $(document).on(eventType, '[' + ATTR + ']', function () {
            tooltipTriggerHandler($(this));
        });
    };

    var tooltipTriggerHandler = function (elem) {
        var data = elem.attr(ATTR);

        if (!data) return;

        container.addClass(elem.attr(ATTR_CLASSNAME) || '');

        data = JSON.parse(data);

        if (!data[SCOREMAP.general]) {
            data[SCOREMAP.general] = {};
        }

        var html = [
            '<div class="event-tooltip-score">',
            '<div class="event-tooltip-score__column">',
            '<div class="event-tooltip-score__header"></div>',
            '<div class="event-tooltip-score__team">' +
                window.Localization.getString(
                    'Scripts_Shared_Modules.TooltipEventScore_32',
                    'К1'
                ) +
                '</div>',
            '<div class="event-tooltip-score__team">' +
                window.Localization.getString(
                    'Scripts_Shared_Modules.TooltipEventScore_33',
                    'К2'
                ) +
                '</div>',
            '</div>',
            '<div class="event-tooltip-score__column">',
            '<div class="event-tooltip-score__header">' +
                window.Localization.getString(
                    'Scripts_Shared_Modules.TooltipEventScore_34',
                    'ОБЩ'
                ) +
                '</div>',
            '<div class="event-tooltip-score__value m-total">' +
                (data[SCOREMAP.general][SCOREMAP.team1] || '0') +
                '</div>',
            '<div class="event-tooltip-score__value m-total">' +
                (data[SCOREMAP.general][SCOREMAP.team2] || '0') +
                '</div>',
            '</div>',
            '<div class="event-tooltip-score__columns-wrapper">',
            getDetailedScoreHtml(data),
            getPointsHtml(data),
            '</div>',
            '</div>',
        ].join('\n');

        innerContainer
            .html(html)
            .promise()
            .done(function () {
                innerContainer.height('auto');
                setPosition(elem);
            });

        dispatchAnalyticsEvent(data, elem)

        if(isMobileDevice) {
            setTooltipVisibility(elem);
            return;
        }

        elem.on('remove', function () {
            hide(elem);
        });
    };

    var getDetailedScoreHtml = function (data) {
        var detailedScoreTableHtml = '';
        if (!data[SCOREMAP.detailed] || data[SCOREMAP.detailed].length === 0)
            return detailedScoreTableHtml;

        for (i = 0; i <= data[SCOREMAP.detailed].length - 1; i++) {
            detailedScoreTableHtml += [
                '<div class="event-tooltip-score__column">',
                '<div class="event-tooltip-score__header">' +
                    (i + 1) +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    data[SCOREMAP.detailed][i][SCOREMAP.team1] +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    data[SCOREMAP.detailed][i][SCOREMAP.team2] +
                    '</div>',
                '</div>',
            ].join('\n');
        }

        return detailedScoreTableHtml;
    };

    var getPointsHtml = function (data) {
        var pointsHtml = '';

        if (
            data[SCOREMAP.points] &&
            data[SCOREMAP.points][SCOREMAP.team1] !== undefined &&
            data[SCOREMAP.points][SCOREMAP.team2] !== undefined
        ) {
            pointsHtml = [
                '<div class="event-tooltip-score__column m-current-score">',
                '<div class="event-tooltip-score__header">' +
                    window.Localization.getString(
                        'Scripts_Shared_Modules.TooltipEventScore_35',
                        'ОЧКИ'
                    ) +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    data[SCOREMAP.points][SCOREMAP.team1] +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    data[SCOREMAP.points][SCOREMAP.team2] +
                    '</div>',
                '</div>',
                '<div class="event-tooltip-score__column m-innings">',
                '<div class="event-tooltip-score__header"></div>',
                '<div class="event-tooltip-score__innings' +
                    (data[SCOREMAP.innings] == 1 ? ' m-active' : '') +
                    '"></div>',
                '<div class="event-tooltip-score__innings' +
                    (data[SCOREMAP.innings] == 2 ? ' m-active' : '') +
                    '"></div>',
                '</div>',
            ].join('\n');
        } else if (data[SCOREMAP.advant] && data[SCOREMAP.advant] != 0) {
            pointsHtml = [
                '<div class="event-tooltip-score__column m-current-score">',
                '<div class="event-tooltip-score__header">' +
                    window.Localization.getString(
                        'Scripts_Shared_Modules.TooltipEventScore_35',
                        'ОЧКИ'
                    ) +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    (data[SCOREMAP.advant] == 1 ? 'A' : '40') +
                    '</div>',
                '<div class="event-tooltip-score__value">' +
                    (data[SCOREMAP.advant] == 2 ? 'A' : '40') +
                    '</div>',
                '</div>',
                '<div class="event-tooltip-score__column m-innings">',
                '<div class="event-tooltip-score__header"></div>',
                '<div class="event-tooltip-score__innings' +
                    (data[SCOREMAP.innings] == 1 ? ' m-active' : '') +
                    '"></div>',
                '<div class="event-tooltip-score__innings' +
                    (data[SCOREMAP.innings] == 2 ? ' m-active' : '') +
                    '"></div>',
                '</div>',
            ].join('\n');
        }

        return pointsHtml;
    };

    var setPosition = function (element) {
        var elementOffset = element.offset(),
            elementWidth = element.outerWidth(),
            tooltipOffset = {
                left: 0,
                top: 0,
            },
            tooltipWidth = container.outerWidth(),
            tooltipHeight = container.outerHeight(),
            positionClassname = 'top';

        const Y_AXIS_MIN = 0,
            PAGE_CONTENT_PADDING = 10;

        // по умолчанию отображается сверху от элемента
        tooltipOffset.left = elementOffset.left + elementWidth - tooltipWidth;
        tooltipOffset.top = elementOffset.top - tooltipHeight;

        container.show();

        container
            .css({
                left: tooltipOffset.left < Y_AXIS_MIN ? PAGE_CONTENT_PADDING : tooltipOffset.left,
                top: tooltipOffset.top,
            })
            .off('transitionend')
            .addClass(positionClassname + ' visible');
    };

    var dispatchAnalyticsEvent = function (d, e) {
        document.dispatchEvent(
            new CustomEvent('showScoreTooltip', {
                detail: {
                    d,
                    element: e[0],
                },
            })
        );
    }

    var setTooltipVisibility = function (e) {
        $(document).on('touchstart', function (eventObject) {
            const isScoreTooltipArea = $('.tooltip--event-score').has(eventObject.target).length;
            if(isScoreTooltipArea) return;
            hide(e);
            $(document).off('touchstart')
            bindMobileUI();
        });
    }

    var hide = function (elem) {
        if (elem) {
            elem.off('remove');
        }

        container.removeClass('visible').on('transitionend', function () {
            container.hide();
            container.removeClass('left right top bottom');
        });
    };

    var update = function (elem) {
        if (elem) tooltipTriggerHandler(elem);
    };

    $(function () {
        TooltipEventScore();
    });

    return {
        update: update,
        hide: hide,
    };
})();
